import {
  formatIp,
  type PdfCell,
  MERGED_CELL_STYLES,
  createPdfTableBlob,
} from './pdf-common';
import { type NodeExportData, type ExportHeaderInfo } from './types';

function formatEnabledPoe(enabled?: boolean): string {
  if (enabled === true) return 'Yes';
  if (enabled === false) return 'No';
  return '';
}

export const buildDevicesPdfBlob = (
  devicesData: NodeExportData[],
  filename: string,
  headerInfo?: ExportHeaderInfo,
): { blob: Blob; filename: string } => {
  const head = [
    'Name',
    'Model',
    'IP',
    'Enabled PoE',
    'VLAN IDs',
    'Connect Node',
    'Connect Port',
    'Notes',
  ];
  const body: PdfCell[][] = [];

  devicesData.forEach((d) => {
    const ipStr = d.IP.map(formatIp).filter(Boolean).join('\n') || '-';
    const maxRows = Math.max(d.Port.length, 1);
    const poeStr = formatEnabledPoe(d.enabledPoe);
    const vlanStr = d.vlanIds?.sort((a, b) => a - b).join(', ') || '';

    for (let i = 0; i < maxRows; i += 1) {
      const p = d.Port[i] || {};
      const portCells = [p.connectNode || '', p.connectPort || ''];
      if (i === 0) {
        body.push([
          { content: d.Name, rowSpan: maxRows, styles: MERGED_CELL_STYLES },
          { content: d.Model, rowSpan: maxRows, styles: MERGED_CELL_STYLES },
          { content: ipStr, rowSpan: maxRows, styles: MERGED_CELL_STYLES },
          { content: poeStr, rowSpan: maxRows, styles: MERGED_CELL_STYLES },
          { content: vlanStr, rowSpan: maxRows, styles: MERGED_CELL_STYLES },
          ...portCells,
          {
            content: d.Notes || '',
            rowSpan: maxRows,
            styles: MERGED_CELL_STYLES,
          },
        ]);
      } else {
        body.push(portCells);
      }
    }
  });

  return createPdfTableBlob(head, body, filename, headerInfo);
};
